/**
 * this file holds all redux constants
 * to avoid spelling mistakes when calling reducers & actions
 *
 * Created by Paul on 7/5/19
 */

const constants = {

    // Funds specific
    SET_FUNDS_LIST_LOADER: 'SET_FUNDS_LIST_LOADER',
    FETCH_FUNDS_SUMMARY_DATA: 'FETCH_FUNDS_SUMMARY_DATA',
    SET_FUNDS_SUMMARY_DATA: 'SET_FUNDS_SUMMARY_DATA',
    FETCH_FUNDS_LIST_DATA: 'FETCH_FUNDS_LIST_DATA',
    SET_FUNDS_LIST_DATA: 'SET_FUNDS_LIST_DATA',
    
    // Fund Specific
    CREATE_NEW_FUND: 'CREATE_NEW_FUND',
    UPDATE_FUND: 'UPDATE_FUND',
    FETCH_IN_PROGRESS_FUND: 'FETCH_IN_PROGRESS_FUND',

    SET_ACTIVE_STEP: 'SET_ACTIVE_STEP',
    SET_CREATE_FUND_FORM: 'SET_CREATE_FUND_FORM',
    SET_FUND_ID: 'SET_FUND_ID',
    FETCH_FUND_OVERALL_POSITION: 'FETCH_FUND_OVERALL_POSITION',
    SET_FUND_POSITION_LOADER: 'SET_FUNDS_POSITION_LOADER',
    SET_FUND_POSITION: 'SET_FUND_POSITION',
    SET_FUND_ASSET_SUMMARY: 'SET_FUND_ASSET_SUMMARY',
    FETCH_FUND_DETAILED_ASSET_POSITION: 'FETCH_FUND_DETAILED_ASSET_POSITION',
    SET_FUND_DETAILED_ASSET_POSITION_LOADER: 'SET_FUND_DETAILED_ASSET_POSITION_LOADER',
    SET_FUND_DETAILED_ASSET_POSITION: 'SET_FUND_DETAILED_ASSET_POSITION',
    FETCH_FUND_CASH_RECONCILIATION: 'FETCH_FUND_CASH_RECONCILIATION',
    SET_FUND_CASH_RECONCILIATION_LOADER: 'SET_FUND_CASH_RECONCILIATION_LOADER',
    SET_FUND_CASH_RECONCILIATION_DATA: 'SET_FUND_CASH_RECONCILIATION_DATA',
    REQUEST_BUSINESS_EVENTS: 'REQUEST_BUSINESS_EVENTS',
    REQUEST_CORPORATE_ACTIONS: 'REQUEST_CORPORATE_ACTIONS',
    FETCH_FUND_CONTRIBUTIONS: 'FETCH_FUND_CONTRIBUTIONS',
    SET_FUND_CONTRIBUTIONS_LOADER: 'SET_FUND_CONTRIBUTIONS_LOADER',
    SET_FUND_CONTRIBUTIONS_DATA: 'SET_FUND_CONTRIBUTIONS_DATA',
    SET_SUBMITTING_FUND_LOADER: 'SET_SUBMITTING_FUND_LOADER',
    FETCH_FUND_SUMMARY_DATA: 'FETCH_FUND_SUMMARY_DATA',
    SET_FUND_SUMMARY_DATA: 'SET_FUND_SUMMARY_DATA',
    FETCH_FUND_SUMMARY_DATA: 'FETCH_FUND_SUMMARY_DATA',

    // Documents specific
    SET_DOCUMNENTS_LOADER: 'SET_DOCUMNENTS_LOADER',
    SET_DOCUMNENTS_DATA: 'SET_DOCUMNENTS_DATA',
    FETCH_DOCUMNENTS_DATA: 'FETCH_DOCUMNENTS_DATA',
    DELETE_DOCUMENT: 'DELETE_DOCUMENT',
    FETCH_DOC_CATEGORIES: 'FETCH_DOC_CATEGORIES',
    SET_DOC_CATEGORIES: 'SET_DOC_CATEGORIES',
    CLEAR_DOCUMENTS_DATA: 'CLEAR_DOCUMENTS_DATA',
    SET_MEMBER_DOC_FOLDER_LOOKUP: 'SET_MEMBER_DOC_FOLDER_LOOKUP',
    SET_DOCUSIGN_DATA: 'SET_DOCUSIGN_DATA',
    GET_DOCUSIGN_DATA: 'GET_DOCUSIGN_DATA',

    // Report specific
    REQUEST_REPORT: 'REQUEST_REPORT',
    DOWNLOAD_REPORT: 'DOWNLOAD_REPORT',

    // Funds page navigation
    LIST: 0,
    VIEW_FUND: 1,
    EDIT_FUND: 2,
    CREATE_FUND: 3,

    // Fund navigation
    OVERVIEW: 0,
    ACTIONS: 1,
    DOCUMENTS: 2,
    MEMBERS: 3,
    CONTRIBUTIONS: 4,




    // componentReducer
    SET_OPEN_LEFT_MENU: 'SET_OPEN_LEFT_MENU',
    SET_OPEN_RIGHT_MENU: 'SET_OPEN_RIGHT_MENU',
    SET_OPEN_CONGRATS_INFO: 'SET_OPEN_CONGRATS_INFO',

    // portfolioReducers
    SET_PORTFOLIO_LOADER: 'SET_PORTFOLIO_LOADER',
    FETCH_PORTFOLIO_DATA: 'FETCH_PORTFOLIO_DATA',
    SET_PORTFOLIO_DATA: 'SET_PORTFOLIO_DATA',
    SET_PORTFOLIO_FUND_VALUE: 'SET_PORTFOLIO_FUND_VALUE',
    SET_PORTFOLIO_FETCH_SUCCESS: 'SET_PORTFOLIO_FETCH_SUCCESS',

    // investmentReducers
    SET_INVESTMENT_LOADER: 'SET_INVESTMENT_LOADER',
    FETCH_INVESTMENT_DATA: 'FETCH_INVESTMENT_DATA',
    SET_INVESTMENT_DATA: 'SET_INVESTMENT_DATA',
    SET_INVESTMENT_FETCH_SUCCESS: 'SET_INVESTMENT_FETCH_SUCCESS',

    // transactionReducers
    SET_TRANSACTION_LOADER: 'SET_TRANSACTION_LOADER',
    SET_TRANSACTION_START_DATE: 'SET_TRANSACTION_START_DATE',
    SET_TRANSACTION_END_DATE: 'SET_TRANSACTION_END_DATE',
    FETCH_TRANSACTION_DATA: 'FETCH_TRANSACTION_DATA',
    SET_TRANSACTION_FETCH_SUCCESS: 'SET_TRANSACTION_FETCH_SUCCESS',
    SET_TRANSACTION_DATA: 'SET_TRANSACTION_DATA',
    SET_TRANSACTION_CLOSING_BALANCE: 'SET_TRANSACTION_CLOSING_BALANCE',
    CLEAR_DATE_RANGE: 'CLEAR_DATE_RANGE',

    // newsReducers
    SET_NEWS_LOADER: 'SET_NEWS_LOADER',
    FETCH_NEWS_DATA: 'FETCH_NEWS_DATA',
    SET_NEWS_DATA: 'SET_NEWS_DATA',

    // userReducer
    SET_USER: 'SET_USER',
    SET_USER_PREFERENCES: 'SET_USER_PREFERENCES',

    // profileReducer
    SET_PROFILE_LOADER: 'SET_PROFILE_LOADER',
    FETCH_PROFILE_DATA: 'FETCH_PROFILE_DATA',
    SET_PROFILE_DATA: 'SET_PROFILE_DATA',
    UPDATE_PROFILE: 'UPDATE_PROFILE',
    EDIT_PROFILE: 'EDIT_PROFILE',

    // fundReducer
    SET_FUND_LOADER: 'SET_FUND_LOADER',
    FETCH_FUND_DATA: 'FETCH_FUND_DATA',
    FETCH_BASIC_FUND_DATA: 'FETCH_BASIC_FUND_DATA',
    SET_FUND_INFO_DATA: 'SET_FUND_INFO_DATA',
    SET_BASIC_FUND_INFO_DATA: 'SET_BASIC_FUND_INFO_DATA',
    SET_MEMBERS_TRUSTEES_DATA: 'SET_MEMBERS_TRUSTEES_DATA',
    SET_COMPANY_DETAILS_DATA: 'SET_COMPANY_DETAILS_DATA',
    CLEAR_FUND_FORM: 'CLEAR_FUND_FORM',
    
    // documentsReducer
    FETCH_DOC_SIGN_STATUS: 'FETCH_DOC_SIGN_STATUS',
    SET_DOC_SIGN_STATUS: 'SET_DOC_SIGN_STATUS',
    FETCH_DOCUMNENTS_DATA: 'FETCH_DOCUMNENTS_DATA',
    SET_DOCUMNENTS_DATA: 'SET_DOCUMNENTS_DATA',
    SET_DOCUMENTS_FETCH_SUCCESS: 'SET_DOCUMENTS_FETCH_SUCCESS',
    SET_DOC_SIGN_STATUS_LOADER: 'SET_DOC_SIGN_STATUS_LOADER',
    FETCH_DOC_SIGN_DETAILS: 'FETCH_DOC_SIGN_DETAILS',
    SET_DOC_SIGN_DETAILS: 'SET_DOC_SIGN_DETAILS',
    FETCH_MEMBER_DOC_DETAILS: 'FETCH_MEMBER_DOC_DETAILS',
    SET_MEMBER_DOC_DETAILS: 'SET_MEMBER_DOC_DETAILS',
    FETCH_MEMBER_DOC_CATEGORIES: 'FETCH_MEMBER_DOC_CATEGORIES',
    SET_MEMBER_DOC_CATEGORIES: 'SET_MEMBER_DOC_CATEGORIES',

    // billingReducers
    SET_BILLING_LOADER: 'SET_BILLING_LOADER',
    FETCH_BILLING_DATA: 'FETCH_BILLING_DATA',
    SET_BILLING_DATA: 'SET_BILLING_DATA',
    SET_BILLING_FETCH_SUCCESS: 'SET_BILLING_FETCH_SUCCESS',

    // referralReducers
    SEND_REFERRAL: 'SEND_REFERRAL',
    SET_REFERRAL_LOADER: 'SET_REFERRAL_LOADER',
    SET_REFERRAL_RESPONSE: 'SET_REFERRAL_RESPONSE',
}

export default constants



// WEBPACK FOOTER //
// ./src/constants.js